export var SCHEMA_TYPES = {
    LOCAL_BUSINESS: 'static-page-local-business',
    SITE_SEARCH: 'static-page-site-search',
    RESTAURANT_SCHEMA: 'static-page-restaurant-schema',
    HOME_PAGE: 'static-page-home-page-schema',
};
